module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.e6d6f705.png";